import { useSettings } from "master";

export const usePrivacy = ({ load = false, key = "" }) => {
  const { settingsInfo } = useSettings({ load, key });
  return {
    settingsInfo,
  };
};
